import {
  ClockCircleOutlined,
  SafetyOutlined,
  StarOutlined,
  TeamOutlined,
  VideoCameraOutlined,
} from '@ant-design/icons';
import BrandLockup from './BrandLockup';
import EnvBadge from './EnvBadge';
import styles from './auth-layout.module.scss';

// Lấy từ các nhóm menu thật (layouts/nav-config.tsx) — không bịa số liệu hay lời chứng thực.
const FEATURES = [
  {
    icon: <TeamOutlined />,
    title: 'Cộng đồng & Creator',
    desc: 'Thành viên, nhóm quản lý, ghép và duyệt Creator mới.',
  },
  {
    icon: <VideoCameraOutlined />,
    title: 'LIVE & Event',
    desc: 'Liveshow, PK Đại chiến, bảng xếp hạng, bình chọn.',
  },
  {
    icon: <ClockCircleOutlined />,
    title: 'Nhân sự & chấm công',
    desc: 'Chấm công, ca làm, nghỉ phép, tăng ca, phiếu lương.',
  },
  {
    icon: <StarOutlined />,
    title: 'Điểm Sao',
    desc: 'Nhiệm vụ, kim cương ngày, cửa hàng, phạt, lịch sử giao dịch.',
  },
];

/**
 * Cột thương hiệu ở màn ≥900px, nền "Đêm" của dải Hoàng hôn (xanh dương đậm, ánh hồng góc trên
 * phải, ánh cam góc dưới trái). Chữ chỉ dùng trắng / onNight; logo giữ nguyên. Nội dung bám đỉnh
 * (logo), giữa (câu giá trị + 4 nhóm) và đáy (dòng tin cậy). Không có nút/CTA — nội dung giới
 * thiệu tách khỏi form.
 */
const BrandPanel = () => (
  <aside className={styles.panel} aria-label="Giới thiệu HP Media">
    <div className={styles.panelTop}>
      <BrandLockup tone="dark" size="md" />
      <EnvBadge />
    </div>

    <div className={styles.panelMiddle}>
      <p className={styles.panelEyebrow}>LIVE Creator Network on TikTok</p>
      <p className={styles.panelValue}>Vận hành mạng lưới Creator HP Media ở mọi nơi.</p>
      <ul className={styles.features}>
        {FEATURES.map((item) => (
          <li key={item.title} className={styles.feature}>
            <span className={styles.featureIcon} aria-hidden="true">
              {item.icon}
            </span>
            <span>
              <span className={styles.featureTitle}>{item.title}</span>
              <span className={styles.featureDesc}>{item.desc}</span>
            </span>
          </li>
        ))}
      </ul>
    </div>

    <p className={styles.panelBottom}>
      <SafetyOutlined aria-hidden="true" />
      <span>
        Chỉ tài khoản được cấp vai trò Admin hoặc MOD mới vào được trang này. Dùng chung tài khoản
        với app HP Media.
      </span>
    </p>
  </aside>
);

export default BrandPanel;
